import React from "react";
import { connect } from "react-redux";
import AppBar from "material-ui/AppBar";
import CaveatVisualization from "../components/CaveatVisualization";
import { getResults, getResponse, answerTextLookup } from "../reducer/response";
import { sortedCategories } from "../reducer/categories";
import { questionLookup } from "../reducer/questions";
import Card, { CardHeader } from "material-ui/Card";
import { Step, Stepper, StepLabel } from "material-ui/Stepper";
import { CardText } from "material-ui/Card";
import { history } from "../index";
import { CUSTOMIZED_ORDER, DEFAULT_ORDER, toggleHiddenOptions } from "../actions/filterOptions";
import LeftMenuButton from "../components/LeftMenuButton";
import RaisedButton from "material-ui/RaisedButton";
import SortIcon from "material-ui/svg-icons/content/sort";
import FlatButton from "material-ui/FlatButton";
import { updateReviewStage } from "../actions/userEdits";
import { Link } from "react-router";
import { makeTitle, questionsAndAnswers, sortedCategories as reducerSortedCategories } from '../reducer';
import Toggle from "material-ui/Toggle";
import {
  toggleOptionHidden,
  bulkToggleOptionsHidden
} from "../actions/userEdits";
import { updateFilterOptions, getSortOrderText } from "../actions/filterOptions";
import FiltersAndSortingOptions from "../components/FiltersAndSortingOptions";
import FlaggedQuestionList from "../components/FlaggedQuestionList";
import InfluentialAnswersList from "../components/InfluentialAnswersList";
import AnswerEditModal from "../components/AnswerEditModal";
import ReportGenerator from "../components/ReportGenerator";
import Dialog from "material-ui/Dialog";
import Divider from "material-ui/Divider";
import {
  saveAnswerNote,
  saveAnswer,
  toggleQuestionFlagged
} from "../actions/response";
import {fetchTranslation} from '../actions/translation';

const sectionNames = {
  monitoring: "Data Collection",
  assessment: "Assessment",
  controlRules: "Management Measures"
};

const stepStyle = active => ({
  fontSize: 16,
  color: active ? "white" : "rgb(202, 202, 202)",
  cursor: "pointer",
  userSelect: "none"
});

const buttonTextStyle = {
  textTransform: "uppercase",
  fontWeight: 500,
  fontSize: 14
};

const starredStyle = {
  minWidth: 16,
  borderRadius: 53,
  backgroundColor: "#ffa100",
  right: 0,
  top: 0,
  textAlign: "center",
  color: "black",
  padding: 5,
  fontSize: 14,
  boxShadow: "2px 2px 2px rgba(0,0,0, 0.5)",
  marginLeft: 6
};

const cardStyle = { width: "98%", margin: "20px auto", position: "relative" };

class ResultsReview extends React.Component {
  state = {
    answerEditorOpen: false,
    question: null,
    answer: null,
    drawerOpen: false,
    filtersOpen: false,
    showGenRptModal: false
  };

  componentDidMount() {
    this.props.updateFilterOptions(
      settings[this.props.stage].filterOptions,
      this.props.section
    );

    if (!this.props.response.userEdits[this.props.section] || !this.props.response.userEdits[this.props.section].reviewStage) { //only autohide if first time in narrowing or haven't completed first step, 2nd clause will be true if reviewstage doesnt exist or equals 0
      var opts = this.props.results.options;
      var higherTiersAvailable = !!opts.find(opt => ((opt.assessmentTier === "data-mid" || opt.assessmentTier === "data-high") && !opt.eliminated));
      var optsElim = opts.filter(r => r.eliminated).map(r => r.id);
      var optsToHide = [];
      if(higherTiersAvailable){
        var optsInLowerTiers = opts.filter(opt => (opt.assessmentTier === "preRiskAssessment") && !opt.eliminated).map(r => r.id);
        optsToHide = optsInLowerTiers.concat(optsElim); //want noneliminated options above eliminated
      } else {
        optsToHide = optsElim;
      }

      this.props.bulkToggleOptionsHidden(
        optsToHide,
        this.props.section,
        this.props.responseID
      );
    }

    if(this.props.response.userEdits.trIDForResponse && this.props.response.userEdits.trIDForResponse !== -1 && !this.props.translation){
      this.props.fetchTranslation(this.props.response.userEdits.trIDForResponse)
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (
      nextProps.stage !== this.props.stage ||
      nextProps.section !== this.props.section
    ) {
      this.props.updateFilterOptions(
        settings[nextProps.stage].filterOptions,
        nextProps.section
      );
    }
  }

  onStepClick(step) {
    history.push(window.location.pathname.replace(/\d$/, step));
    window.scrollTo(0, 0);
    this.props.updateFilterOptions(
      settings[step].filterOptions,
      this.props.section
    );
    this.props.updateReviewStage(
      step,
      this.props.section,
      this.props.responseID
    );
  }

  onDrawerRequestChange = drawerOpen => {
    this.setState({ drawerOpen });
  };

  onToggleHideOptions() {
    this.props.toggleHiddenOptions(this.props.section)
  };

  onQuestionClick(id) {
    let question = this.props.questions.find(q => q.id === id);
    if (question) {
      let answer = this.props.answers[question.id];
      let trQuestion = this.props.translation ? this.props.translation.questions.find(trQ => trQ.engID === question.id) : null
      this.setState({
        answerEditorOpen: true,
        question: question,
        answer: answer,
        trQuestion:trQuestion
      });
    }
  }

  onAnswerModalClose() {
    this.setState({
      answerEditorOpen: false,
      answer: null
    });
  }

  render() {
    const {
      response,
      section,
      results,
      answerTextLookup,
      questionLookup,
      responseID,
      filterOptions,
      categories,
      stage,
      onToggleOptionHidden,
      starred
    } = this.props;
    let options;
    const activeStep = parseInt(stage);
    let step = 0;
    const stageSettings = settings[activeStep];
    if (stageSettings.previewList) {
      options = results.options.slice(0, 12);
    } else if (stageSettings.shortList) {
      options = results.options.filter(o => starred.indexOf(o.id) !== -1);
    } else {
      options = results.options;
    }

    const instructionText = getSortOrderText(filterOptions.order, section).description;
    const title = getSortOrderText(filterOptions.order).title;

    return (
      <React.Fragment>
        <div
          style={{
            zIndex: 2,
            position: "fixed",
            top: 0,
            backgroundColor: "rgb(11, 94, 147)",
            width: "100%",
            height: "auto"
          }}
        >
          <AppBar
            style={{
              backgroundColor: "rgb(11, 94, 147)"
            }}
            title={`Results Review - ${makeTitle(response)} - ${
              sectionNames[section]
            }`}
            children={
              <LeftMenuButton
                open={this.state.drawerOpen}
                onRequestChange={this.onDrawerRequestChange}
              />
            }
            onLeftIconButtonClick={() => this.setState({ drawerOpen: true })}
          />
          <div>
            <Stepper
              activeStep={activeStep}
              style={{ maxWidth: 1200, margin: "0px auto" }}
            >
              <Step onClick={this.onStepClick.bind(this, step++)}>
                <StepLabel style={stepStyle(activeStep === step - 1)} icon={1}>
                  Option Retention
                </StepLabel>
              </Step>
              <Step onClick={this.onStepClick.bind(this, step++)}>
                <StepLabel style={stepStyle(activeStep === step - 1)} icon={2}>
                  Identification of Top Options
                  {starred.length ? (
                    <span style={starredStyle}>{starred.length}</span>
                  ) : null}
                </StepLabel>
              </Step>
              <Step onClick={this.onStepClick.bind(this, step++)}>
                <StepLabel style={stepStyle(activeStep === step - 1)} icon={3}>
                  Critical Evaluation of Top Options
                </StepLabel>
              </Step>
            </Stepper>
          </div>
        </div>
        <div style={{ paddingTop: 140 }}>
          <Card style={cardStyle}>
            <CardHeader title="Instructions" />
            <CardText>{getIntro(section, activeStep)}</CardText>
            <div style={{ textAlign: "center" }}>
              <RaisedButton
                label="Back"
                labelPosition="before"
                style={{ margin: "0px auto" }}
                onClick={this.onPrevStepClick}
                disabled={stage === 0}
              />
              <RaisedButton
                label="Exit Review"
                style={{ margin: "10px" }}
                containerElement={
                  <Link
                    to={`/questionnaire/results/${responseID}/${section}/`}
                  />
                }
              />
              {
                  activeStep === 2 ?<RaisedButton
                  onClick={this.handleGenerateReportClick.bind(null, section)}
                  label="Generate Report"
                  style={{ marginRight: "10px" }}
                /> : null
              }
              <RaisedButton
                primary
                label={activeStep === 2 ? "Finish" : "Next Step"}
                labelPosition="before"
                style={{ margin: "0px auto" }}
                onClick={this.onNextStepClick}
              />
            </div>
          </Card>

          <Card style={cardStyle}>
              <div style={{display:"inline-flex", justifyContent:"space-between", width: "100%"}}>
                <div style={{fontSize:14, marginTop:15, marginLeft:10}}>
                  <b>Current Sorting Method:</b> <i>{title}</i> - {instructionText}
                </div>
                <div
                style={{
                  display: "inline-flex",
                  minWidth:this.props.stage === 0 ? 380 : 165,
                  float:"right",
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  paddingTop:5,
                  paddingRight:5,
                  ...buttonTextStyle,
                }}>
                  <Toggle
                  label="Show Hidden Options"
                  onClick={this.onToggleHideOptions.bind(this)}
                  labelPosition="left"
                  toggled={filterOptions.displayHiddenOptions}
                  style={{
                    display: "inline-block",
                    width: "auto",
                    marginRight:10,
                    display: this.props.stage === 0 ? "block" : "none",
                    ...buttonTextStyle
                  }}
                  thumbStyle={{
                    backgroundColor: "rgb(0, 188, 212)"
                  }}
                />

                <RaisedButton
                  label="Sort Options"
                  labelPosition="before"
                  icon={<SortIcon />}
                  style={{
                    position: "inline-block",
                    display: stageSettings.showFiltersAndSorting ? "block" : "none"
                  }}
                  onClick={() => this.setState({ filtersOpen: true })}
                />
              </div>
            </div>
            <CaveatVisualization
              displayCriteria={section !== "controlRules"}
              colorCodedCriteria={section === "assessment"}
              onNoteClick={() => {}}
              onOptionClick={() => {}}
              // onQuestionClick={this.onQuestionClick}
              section={section}
              answerTextLookup={answerTextLookup}
              questionLookup={questionLookup}
              {...results}
              options={options}
              readOnly={false}
              responseID={responseID}
              onToggleOptionHidden={(option, section) =>
                onToggleOptionHidden(option, section, responseID)
              }
              userEdits={response.userEdits}
              fishery={makeTitle(response)}
              filterOptions={filterOptions}
              categories={categories}
              hideAllOptionsLink={true}
              response={response}
              enabledActions={stageSettings.actions}
            />
            <div style={{ textAlign: "center" }}>

                <RaisedButton
                label="Back"
                labelPosition="before"
                style={{ margin: "0px auto" }}
                onClick={this.onPrevStepClick}
                disabled={stage === 0}
              />
              <RaisedButton
                label="Exit Review"
                style={{ margin: "10px" }}
                containerElement={
                  <Link to={`/questionnaire/results/${responseID}/${section}/`} />
                }
              />
              {
                  activeStep === 2 ?<RaisedButton
                  onClick={this.handleGenerateReportClick.bind(null, section)}
                  label="Generate Report"
                  style={{ marginRight: "10px" }}
                /> : null
              }
              <RaisedButton
                primary
                label={activeStep === 2 ? "Finish" : "Next Step"}
                labelPosition="before"
                style={{ margin: "0px auto" }}
                onClick={this.onNextStepClick}
              />
            </div>
          </Card>



          <Card style={{...cardStyle, marginBottom:20}}>

            <Divider />

            <FlaggedQuestionList
              answerTextLookup={answerTextLookup}
              readOnly={this.props.readOnly}
              responseID={responseID}
              onItemClick={this.onQuestionClick.bind(this)}
              questions={this.props.flaggedQuestions}
              section={section}
              translation={this.props.translation}
            />
            <Divider />
            <InfluentialAnswersList
              section={section}
              readOnly={this.props.readOnly}
              responseID={responseID}
              onItemClick={this.onQuestionClick.bind(this)}
              answers={this.props.influentialAnswers}
              answerTextLookup={answerTextLookup}
              options={this.props.options}
              translation={this.props.translation}
            />
          </Card>

          <FiltersAndSortingOptions
            section={this.props.section}
            open={!!this.state.filtersOpen}
            onRequestClose={() => this.setState({ filtersOpen: false })}
          />

          <AnswerEditModal
            response={this.props.response}
            readOnly={this.props.readOnly}
            open={this.state.answerEditorOpen}
            question={this.state.question}
            answer={this.state.answer}
            trQuestion={this.state.trQuestion}
            onRequestClose={this.onAnswerModalClose.bind(this)}
            onSave={this.onAnswerSave}
            onSaveNote={this.handleSaveAnswerNote}
            onToggleFlagged={this.onToggleFlagged}
            section={section}
          />

          {/*report generate view*/}
          <Dialog
            open={!!this.state.showGenRptModal}
            autoScrollBodyContent={true}
            actions={[
              <FlatButton
                label="Cancel"
                onClick={this.closeGenRptModal.bind(this)}
              />,
              <RaisedButton
                onClick={this.handleGenerateReports}
                primary={true}
                label="Generate"
              />
            ]}
            title="Choose options to include in the report:"
          >
            <ReportGenerator
              rptType="results"
              options={this.state.reportOptions}
              answerTextLookup={this.props.answerTextLookup}
              answers={this.props.answers}
              questionLookup={this.props.questionLookup}
              monitoringQuestions={this.props.monitoringQuestions}
              assessmentQuestions={this.props.assessmentQuestions}
              controlRulesQuestions={this.props.controlRulesQuestions}
              categories={this.props.questionCategories}
              sections={['monitoring', 'assessment', 'controlRules']}
              notesList={this.props.userNotes}
              section={this.state.showGenRptModal}
              fishery={makeTitle(this.props.response)}
              onCheck={this.onReportOptCheck}
              ref="reportGenerator"
              starred={starred}
              translation={this.props.translation}
            />
          </Dialog>

        </div>
      </React.Fragment>
    );
  }

handleGenerateReportClick = section => {
  this.setState({
    showGenRptModal: section,
    //always show starred options only
    reportOptions: this.props.results.options.filter(
        o => this.props.response.userEdits[section] ? this.props.response.userEdits[section].starred.indexOf(o.id) !== -1 : false
      )
  });
};

handleGenerateReports = () => {
  let reportType = this.refs.reportGenerator.state.tabValue;
  this.refs.reportGenerator.genReports(reportType);
  this.closeGenRptModal();
};

closeGenRptModal() {
  this.setState({
    showGenRptModal: false
  });
}

  onAnswerSave = (questionID, value, section) => {
    this.props.saveAnswer(questionID, value, section, this.props.response);
  };

  onToggleFlagged = questionID => {
    this.props.toggleFlagged(questionID, this.props.response);
  };

  handleSaveAnswerNote = (id, value, response) => {
    this.props.saveAnswerNote(id, value, response);
    this.setState({
      answer: {
        ...this.state.answer,
        note: value
      }
    });
  };

  onNextStepClick = () => {
    if (this.props.stage >= 2) {
      history.push(
        window.location.pathname
          .replace(/\d$/, "")
          .replace("resultsReview", "questionnaire/results")
      );
    } else {
      this.onStepClick(this.props.stage + 1);
    }
  };

  onPrevStepClick = () => {
    if (this.props.stage === 0) {
      history.push(
        window.location.pathname
          .replace(/\d$/, "")
          .replace("resultsReview", "questionnaire/results")
      );
    } else {
      this.onStepClick(this.props.stage - 1);
    }
  };
}

const mapStateToProps = (state, ownProps) => {
  var section = ownProps.params.section;
  let fetching = false;
  fetching = state.responses.fetching;
  let response = getResponse(state);
  let readOnly = response
    ? response.email !== state.auth.email && !state.auth.isAdmin
    : true;
  const results = getResults(state);
  let stage = parseInt(ownProps.params.stage);
  stage = stage > 2 ? stage - 2 : stage; // removed the original 1st two steps so need to handle prior fisheries states that were past stage 2
  let trIDForResponse = response.userEdits ? response.userEdits.trIDForResponse : -1;
  let translation = (trIDForResponse !== -1) ? state.translations.find((t) => t.id === trIDForResponse) : null;
  return {
    results: results[section],
    tabs: Object.keys(results)
      .filter(k => k !== "scores")
      .map(key => ({ name: key, results: results[key] })),
    responseID: response ? response.metadata.id : ownProps.params.id,
    section: section,
    questions: state.questions,
    categories: (sortedCategories(state.categories) || []).filter(
      c => c.type === "target" || c.type === "option"
    ),
    answers: response ? response.answers : {},
    answerTextLookup: answerTextLookup(state),
    questionLookup: questionLookup(state),
    flaggedQuestions: results[section].flaggedQuestions,
    influentialAnswers: results[section].influentialAnswers,
    fetchingResponse: fetching,
    readOnly: readOnly,
    response: response,
    monitoringQuestions: questionsAndAnswers.monitoring(state), //TODO: migrate this over to fix bug where resultsreview is always printing the results report instead of answer report
    assessmentQuestions: questionsAndAnswers.assessment(state),
    controlRulesQuestions: questionsAndAnswers.controlRules(state),
    questionCategories: reducerSortedCategories(state),
    translation: translation,
    userNotes: (response.userEdits || {}).userNotes || {},
    filterOptions: state.filterOptions ? state.filterOptions[section] : {},
    stage: stage,
    starred:
      (response &&
        response.userEdits &&
        response.userEdits[section] &&
        response.userEdits[section].starred) ||
      []
  };
};

const mapDispatchToProps = (dispatch, getState) => {
  return {
    onToggleOptionHidden: (option, section, responseID) =>
      dispatch(toggleOptionHidden(option, section, responseID)),
    updateFilterOptions: (options, section) =>
      dispatch(updateFilterOptions(options, section)),
    bulkToggleOptionsHidden: (ids, section, responseID) =>
      dispatch(bulkToggleOptionsHidden(ids, section, responseID)),
    updateReviewStage: (stage, section, responseID) =>
      dispatch(updateReviewStage(stage, section, responseID)),
    toggleHiddenOptions: (section) =>
      dispatch(toggleHiddenOptions(section)),
    saveAnswer: (id, value, section, response) =>
      dispatch(saveAnswer(id, value, section, response)),
    saveAnswerNote: (id, value, response) =>
      dispatch(saveAnswerNote(id, value, response)),
    toggleFlagged: (id, response) =>
      dispatch(toggleQuestionFlagged(id, response)),
    fetchTranslation: (id) => dispatch(fetchTranslation(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResultsReview);

const intros = {
  0: (
    <div>
    <i>Purpose of this step</i>: Quickly narrow down the list by removing options that are clearly not viable, while keeping options worth further discussion and exploration.

    To do this, use the “hide” and “un-hide” buttons in each option row. All options where criteria were not met have automatically been hidden (greyed out). Hidden options will not be shown in the next steps.

      <ol>
        <li>Unhide any hidden options worth reinstating.</li>
        <li>Use the default sort and hide any options after reviewing the top of the list with the most warnings.</li>
        <li>Sort by category (noting that options are repeated across categories). Hide entire categories or options within categories that are not within the goals or scope of the project (e.g. “To learn more about the fishery” is the most basic of data requirements. Fisheries beyond that do not need to retain that category of data). </li>
        <li>Sort by option name, then hide any other options that are clearly inconsistent with legislation or on-the-ground conditions, while keeping options worth further discussion and exploration.</li>
        <li>After review of influential answers and related caveats, hide options where caveats flagged cannot be corrected for.</li>
      </ol>
    </div>
  ),
  1: (
    <div>
      Second, we want to work through remaining options and prioritize (star)
      the “top” options. Starring an option will automatically move it to a
      short-list for detailed exploration. Consider starring options not
      currently available, but those that may become available. Star the options
      that are:
      <ol>
        <li>Already being implemented that will continue to be considered.</li>
        <li>
          Currently being considered for future implementation or options that
          stakeholders would like to explore in detail.
        </li>
        <li>
          Demonstrate a high proportion of positive (green) attributes relative
          to warning (yellow/orange/red) caveats;
        </li>
        <li>Of interest in any other regard. </li>
      </ol>
    </div>
  ),
  2: (
    <div>
      Third, we want to take a detailed review of the Top Options and any
      remaining options of interest, and undertake thorough considerations of
      caveats.
      <ol>
        <li>
          For each of the Top Options, consider the caveats in detail: identify
          whether, and how, each caveat would be overcome.
        </li>
        <li>
          If applicable and if desired, drag and drop function can be used to
          begin ranking top options.
        </li>
      </ol>
    </div>
  )
};

const sectionIntros = {
  monitoring: {
    0: (
      <div>
        <i>Purpose of this step:</i> Quickly narrow down the list by removing options that are clearly not viable, while keeping options worth further discussion and exploration.
        <br/><br/>
        To do this, use the “hide” and “un-hide” buttons in each option row. All options where criteria were not met have automatically been hidden (greyed out). Hidden options will not be shown in the next steps.

        <ol>
          <li>Review the automatically hidden options and unhide any hidden options that warrant more exploration or are already being implemented.</li>
          <li>Sort by category (noting that options are repeated across multiple categories). Hide entire categories or options within categories that are not within the goals or scope of the project (e.g. “To learn more about the fishery” is the most basic of data requirements. Fisheries beyond that do not need to retain that category of data).</li>
          <li>Sort by option name, then hide any other options that are clearly inconsistent with legislation or on-the-ground conditions.</li>
          <li>Use the influential answer list and sorting by default to review the red caveats of each remaining option. Hide any options whose red caveats obviously cannot be overcome.</li>
        </ol>
      </div>
    ),
    1: (
      <div>
        <i>Purpose of this step:</i> Choose a handful of best possible options for your fishery to critically evaluate for building the harvest strategy. Your harvest strategy will likely use multiple options that work complementary to each other. You may also select options to compare against each other in the final step knowing that you might not use all of these top options in your harvest strategy.
        <br/><br/>
        Create the short list of top or prioritized options by clicking the star icon. Starring an option will move it to a short-list for detailed exploration. Star options that are:

        <ol>
          <li>Already being implemented that will continue to be considered or evaluated.</li>
          <li>Being considered for future implementation or options that stakeholders would like to explore in detail.</li>
          <li>Determined to be a potential good fit for the fishery based upon review of the option description and caveats. A good rule of thumb is that the option has less red, orange or yellow warning caveats than other possibilities, or that these are readily able to be addressed or overcome.</li>
          <li>Of interest in any other regard.</li>
        </ol>
        Additional considerations:
        <ul>
          <li>Consider key deficiencies or weaknesses in existing data collection protocols and how they could be expanded or improved.</li>
          <li>Make a note of where top options are being considered as alternative or corroborative data streams. In the final data collection plan, you will want to avoid unnecessary (and costly) overlaps (repeated sources of data), while acknowledging the value of corroboration across multiple sources of information.</li>
        </ul>

      </div>

    ),
    2: (
      <div>
        <i>Purpose of this step:</i> Conduct a detailed review of the top options and their caveats. Compare the advantages and disadvantages of using different options or different suites of options and create a roadmap for how to develop a harvest strategy based on these results.
        <ol>
          <li>For each of the Top Options, consider the caveats in detail: identify whether, and how, each caveat would be overcome.
            <ol type="a">
              <li>Add notes to each option to capture these details and be able to share the outcomes of this discussion.</li>
              <li>If a caveat is determined to be too determentral and unable to be addressed, then un-star the option to remove it from the top option list.</li>
            </ol>
          </li>
          <li>If helpful in talking through the top options, use the drag and drop function (customized sort order) to rank the top options.</li>
          <li>Discuss the next steps for using these top options to build a harvest strategy or develop management actions to take.</li>
          <li>Download a report of the top options including the notes taken.</li>
        </ol>
      </div>
    )
  },
  assessment: {
    0: (
      <div>
        <i>Purpose of this step:</i> Quickly narrow down the list by removing options that are clearly not viable, while keeping options worth further discussion and exploration.
        <br/><br/>
        To do this, use the “hide” and “un-hide” buttons in each option row. All options where criteria were not met (that is, one or more required model inputs were not available) have automatically been hidden (greyed out). If any assessments in the mid or high ‘tiers’ pass criteria, then the options in the stock prioritization ‘tier’ have also been automatically hidden, regardless of criteria.

        <ol>
          <li>Review the automatically hidden options and unhide any hidden options that warrant more exploration or are already being implemented.</li>
          <li>If there are known outputs that management cannot use (e.g., unable to enforce catch limits), then sort by the assessment output category and hide options that produce these outputs.</li>
          <li>Review the influential answers and related caveats and hide options where caveats flagged cannot be overcome.</li>
          <li>Sort by default and review the remaining red caveats. Hide any options whose red caveats obviously cannot be overcome.</li>
          <li>Where more data-moderate assessment options are available, consider hiding the more data-limited options (for example, a production model will almost always be preferable to the use of discourse/expert judgement to determine stock status). Exceptions are where these more data-limited options yield valuable augmentary information or insight (e.g. an analysis of changes in species composition may be valuable to augment single-species assessments in a multispecies fishery, or analysis of spatial catch or effort patterns may detect localised depletion not identified by a whole-of-stock assessment).</li>
        </ol>
      </div>
    ),
    1: (
      <div>
        <i>Purpose of this step:</i> Choose a handful of best possible options for your fishery to critically evaluate for building the harvest strategy. Your harvest strategy will likely use multiple options that work complementary to each other. You may also select options to compare against each other in the final step knowing that you might not use all of these top options in your harvest strategy.
        <br/><br/>
        Create the short list of top or prioritized options by clicking the star icon. Starring an option will move it to a short-list for detailed exploration. Star options that are:

        <ol>
          <li>Already being implemented that will continue to be considered or evaluated.</li>
          <li>Being considered for future implementation or options that stakeholders would like to explore in detail.</li>
          <li>Determined to be a potential good fit for the fishery based upon review of the option description and caveats. A good rule of thumb is that the option has less red, orange or yellow warning caveats than other possibilities, or that these are readily able to be addressed or overcome.</li>
          <li>In higher assessment 'tiers' or allow for more uncertainty to be explored.</li>
          <li>Of interest in any other regard.</li>
        </ol>

        Additional considerations:
        <ul>
          <li>Consider key deficiencies or weaknesses in existing assessments and how they could be expanded or improved.</li>
          <li>If available, it is recommended to include alternative assessments that utilize independent data sets for exploration. These may be used to populate harvest strategy frameworks, such as a decision tree or traffic light based approaches. Comparison of outputs between assessments that use independent data sources may provide additional information worth considering in a management context.</li>
          <li>Consider augmenting assessments with data-limited options where the data-limited option can yield valuable insight not captured by a mid or high ‘tier’ assessment (e.g. an analysis of changes in species composition may be valuable to augment single-species assessments in a multispecies fishery, or analysis of spatial catch or effort patterns may detect localised depletion not identified by a whole-of-stock assessment).</li>
        </ul>
      </div>
    ),
    2: (
      <div>
        <i>Purpose of this step:</i> Conduct a detailed review of the top options and their caveats. Compare the advantages and disadvantages of using different options or different suites of options and create a roadmap for how to develop a harvest strategy based on these results.
        <ol>
          <li>For each of the top options, consider the caveats in detail: identify whether, and how, each caveat can be overcome.
            <ol type="a">
              <li>Add notes to each option to capture these details and be able to share the outcomes of this discussion.</li>
              <li>If a caveat is determined to be too determentral and unable to be addressed, then un-star the option to remove it from the top option list.</li>
            </ol>
          </li>
          <li>If helpful in talking through the top options, use the drag and drop function (customized sort order) to rank the top options.</li>
          <li>Consider each red, orange and yellow color around the <b>criteria</b> that are met. Be mindful that a higher number of (in particular, red and orange) warning colors will likely confer high uncertainty to the assessment output.</li>
          <li>It is recommended to select methods from higher assessment 'tiers' over methods in lower 'tiers', but consider how lower ‘tier’ assessment might be able to augment and provide insight not captured in mid or high ‘tier’ assessments.</li>
          <li>Discuss the next steps for using these top options to build a harvest strategy or develop management actions to take.</li>
          <li>Download a report of the top options including the notes taken.</li>
        </ol>
      </div>
    )
  },
  controlRules: {
    0: (
      <div>
        <i>Purpose of this step:</i> Quickly narrow down the list by removing options that are clearly not viable, while keeping options worth further discussion and exploration.
        <br/><br/>
        To do this, use the “hide” and “un-hide” buttons in each option row. All options where criteria were not met have automatically been hidden (greyed out). Hidden options will not be shown in the next steps.

        <ol>
        <li>Sort by category and hide categories that are not relevant or available to the fishery.</li>
        <li>Hide any other options that are inconsistent with legislation or on-the-ground conditions.</li>
        <li>Review the influential answers and related caveats and hide options where caveats flagged cannot be overcome.</li>
        <li>Sort by default and review the remaining red caveats and hide any options whose red caveats obviously cannot be overcome.</li>
        </ol>
      </div>
    ),
    1: (
      <div>
        <i>Purpose of this step:</i> Choose a handful of best possible options for your fishery to critically evaluate for building the harvest strategy. Your harvest strategy will likely use multiple options that work complementary to each other. You may also select options to compare against each other in the final step knowing that you might not use all of these top options in your harvest strategy.
        <br/><br/>
        Create the short list of top or prioritized options by clicking the star icon. Starring an option will move it to a short-list for detailed exploration. Star options that are:

      <ol>
        <li>Already being implemented that will continue to be considered or evaluated.</li>
        <li>Being considered for future implementation or options that stakeholders would like to explore in detail. This includes options not currently available, but could become available under desired scenarios.</li>
        <li>Suggested by an assessment, whether the assessment is currently used or is a top option in FishPath</li>
        <li>Determined to be a potential good fit for the fishery based upon review of the option description and caveats. A good rule of thumb is that the option has less red, orange or yellow warning caveats than other possibilities, or that these are readily able to be addressed or overcome.</li>
        <li>Of interest in any other regard.</li>
      </ol>

      Additional considerations:
      <ul>
        <li>Consider key deficiencies or weaknesses in existing management measures. Also consider how existing measures could be expanded or improved.</li>
        <li>No one management measure can fully address all aspects of a sustainable fishery. Consider how management measures can be used together to complement each other, given the identified issues within the fishery.</li>
        <li>Implementing new management measures can impact other aspects of the harvest strategy. This is especially true if the only data being collected are from fishery-dependent sources. </li>
        <li>Management measures may also have unintended effects on co-occurring species to those being managed. Be sure to consider what effects the new management measures might have on the harvest strategy and ecosystem.</li>
      </ul>
      </div>
    ),
    2: (
      <div>
        <i>Purpose of this step:</i> Conduct a detailed review of the top options and their caveats. Compare the advantages and disadvantages of using different options or different suites of options and create a roadmap for how to develop a harvest strategy based on these results.
        <ol>
          <li>For each of the top options, consider the caveats in detail: identify whether, and how, each caveat can be overcome.
            <ol type="a">
              <li>Add notes to each option to capture these details and be able to share the outcomes of this discussion.</li>
              <li>If a caveat is determined to be too determentral and unable to be addressed, then un-star the option to remove it from the top option list.</li>
            </ol>
          </li>
          <li>If helpful in talking through the top options, use the drag and drop function (customized sort order) to rank the top options.</li>
          <li>Discuss the next steps for using these top options to build a harvest strategy or develop management actions to take.</li>
          <li>Download a report of the top options including the notes taken.</li>
        </ol>
      </div>
    )
  }
};

const getIntro = (section, stage) => {
  if (
    sectionIntros &&
    sectionIntros[section] &&
    sectionIntros[section][stage]
  ) {
    return sectionIntros[section][stage];
  } else {
    return intros[stage];
  }
};

const settings = {
  // first step, elimination
  0: {
    showFiltersAndSorting: true,
    filterOptions: {
      displayHiddenOptions: true,
      order: DEFAULT_ORDER,
      hideTags: false
    },
    actions: {
      hide: true,
      star: false
    },
    shortList: false
  },
  // pick short list
  1: {
    showFiltersAndSorting: true,
    filterOptions: {
      displayHiddenOptions: false,
      // order: DEFAULT_ORDER,
      hideTags: false
    },
    actions: {
      hide: false,
      star: true
    },
    shortList: false
  },
  // organize list
  2: {
    showFiltersAndSorting: true,
    filterOptions: {
      displayHiddenOptions: false,
      order: CUSTOMIZED_ORDER,
      hideTags: false
    },
    actions: {
      hide: false,
      star: true
    },
    shortList: true
  }
};
